<template>
  <div class="e-dialog-body" :class="classes">
    <e-btn
      v-if="props.variant === 'dialog'"
      class="e-dialog-body__close-btn"
      variant="ghost"
      size="small"
      icon="icon-close-sign"
      @click="emit('click:close')" />
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { EBtn } from '../EBtn';

const props = defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'dialog', 'modal'].includes(value),
  },
})
const emit = defineEmits(['click:close'])

const classes = computed(() => {
  return {
    [`e-variant--${props.variant}`]: true,
  }
})
</script>

<style lang="scss">
@import '../../scss/styles';
@import 'vuetify/lib/styles/settings/variables';

.e-dialog-body {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: $whitebase;
  border: 1px solid $grayscale300;
  border-radius: 6px;
  &__close-btn {
    position: absolute;
    right: 8px;
    top: 8px;
  }

  &.e-variant--modal {
    .e-dialog-actions {
      justify-content: flex-end;
    }
  }
  &.e-variant--default {
    .e-dialog-actions {
      justify-content: center;
    }
  }
  &.e-variant--dialog {
    .e-dialog-actions {
      justify-content: center;
      padding: 0 16px 16px;
    }
    .e-dialog-content {
      display: flex;
      flex-direction: column;
      gap: 32px;
      padding: 16px;
    }
  }
}

.v-theme--dark {
  .e-dialog-body {
    border-color: $grayscale700;
    background: $graybase;
    color: $whitebase;
  }
}

@media #{map-get($display-breakpoints, 'xs')} {
  .e-dialog-body {
    border: none;
    border-radius: 16px 16px 0 0;
    &.e-variant--dialog {
      .e-dialog-actions {
        flex-direction: column-reverse;
        padding: 0 16px 16px;
        gap: 12px;
      }
    }
  }
}
</style>
